/* wsapi3-checkout-cart v1.0 */
/* Deploy Version 2026-10-30 03:32:45 */
/* Deploy Version 2026-09-24 19:11:09 */
/* Deploy Version 2026-07-27 16:11:02 */
// ws-checkout-cart2 — display-only module
// Loads cart data via ApiWS.Calls.cartView() and renders using the same
// HTML/CSS structure as ws-checkout-cart v1.0, without interactive handlers.

(function () {
    const _wsCart1XDescount = (typeof over_wsCart1XDescount !== 'undefined') ? over_wsCart1XDescount : false;
    const _wsCartFinishButtonLabel = (typeof over_wsCartFinishButtonLabel !== 'undefined') ? over_wsCartFinishButtonLabel : 'FINALIZAR COMPRA';
    const _wsCartFinishBoletoPixMsg = (typeof over_wsCartFinishBoletoPixMsg !== 'undefined') ? over_wsCartFinishBoletoPixMsg : 'no boleto ou PIX ';

    wsMain.createModule({
        name: 'checkout-cart2',
        version: '1.0',
        updatedAt: '2026-07-07',
        function: 'get',

        factoryFunctions: {
            formatPrices: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }),
            cartPrices: { productTotal: 0, cashDiscount: 0, cashDiscountEligibleTotal: 0, shipping: 0 },

            getCashDiscountEligibleTotal(data) {
                try {
                    if (!data?.products?.length) return 0;
                    return data.products.reduce((sum, p) => {
                        if (!p || p.storeGift || p.cash_price_apply !== true) return sum;
                        return sum + (Number(p.real_price || 0) * Number(p.quantity || 0));
                    }, 0);
                } catch (e) { return 0; }
            },

            createProds(prodsArr) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;

                if (!prodsArr?.length) {
                    document.querySelector('.checkout-content > main')?.classList.add('popupHidden');
                    document.querySelector('.checkout-content > .resumo')?.classList.add('popupHidden');
                    document.querySelector('.float-resume')?.classList.add('popupHidden');
                    document.querySelector('.checkout-content > .voltarCompras')?.classList.remove('popupHidden');
                    return;
                }

                const container = document.querySelector('#ws-carrinhoNovo .checkout-content .itensCarrinho');
                if (!container) return;

                const productsStr = prodsArr.map(prod => {
                    const isGift = !!prod.storeGift;
                    const origPrice = ff.formatPrices.format(prod.original_price);
                    const realPrice = ff.formatPrices.format(prod.real_price);
                    const cashBack = prod.cashback?.valor ? ff.formatPrices.format(prod.cashback.valor) : '';
                    const giftPackAmt = prod.gift_packaging?.active ? ff.formatPrices.format(prod.gift_packaging.amount) : '';

                    const giftPackEl = (!isGift && giftPackAmt) ? `
                <div class="presenteOption">
                    <div class="embrulharPresentes">
                        <label>
                            <div>
                                <input type="checkbox" class="embrulhar" name="embrulharPresente" ${prod.gift_packaging?.status ? 'checked' : ''}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="7.984" height="5.719" viewBox="0 0 7.984 5.719">
                                <path d="M151.5,1792.954l1.954,1.954,3.909-3.909" transform="translate(-150.439 -1789.939)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                </svg>
                            </div>
                            <span>Embrulhar para presente</span>
                        </label>
                    </div>
                    <div class="produtoPrecos__valores"><p class="valores__preco">${giftPackAmt}</p></div>
                </div>` : '';

                    const cashBackEl = (!isGift && cashBack) ? `
                <div class="prod__cashBack">
                    <p class="cashBack__msg"><span>Ganhe ${cashBack} de cashback</span></p>
                </div>` : '';

                    const vars = prod.add_info
                        ? prod.add_info.map(e => `<p variation="${e.title.split(' ')[0]}">${e.title}: ${e.value}</p>`).join('')
                        : '';

                    const priceHtml = isGift
                        ? `<p class="valores__desconto valores__brinde">Brinde</p>`
                        : `<p class="valores__preco" style="${prod.original_price ? '' : 'display:none;'}">${origPrice}</p>
                           <p class="valores__desconto">${realPrice}</p>
                           <p class="valores__desconto__un" style="display:none">(${realPrice})</p>`;

                    const qtyHtml = isGift
                        ? `<div class="quantidadeProdutos__btns quantidadeProdutos__btns--locked">
                               <input type="text" class="quantidadeProdutos__btns__qnt" value="${prod.quantity}" maxlength="3" disabled>
                           </div>`
                        : `<div class="quantidadeProdutos__btns">
                               <span class="quantidadeProdutos__button quantidadeProdutos__btns__sub">-</span>
                               <input type="text" class="quantidadeProdutos__btns__qnt" value="${prod.quantity}" maxlength="3">
                               <span class="quantidadeProdutos__button quantidadeProdutos__btns__add">+</span>
                           </div>`;

                    const oosClass = Number(prod.quantity) === 0 ? ' itemCar--oos' : '';

                    return `
            <div class="itemCar${oosClass}" prod-price="${prod.real_price}" itemId="${prod.itemId}" groupId="${prod.groupId}" productId="${prod.productId}" storeGift="${isGift}">
                <a href="${prod.url}" target="_blank" class="produtoImg">
                    <img src="${prod.photo}" alt="imagem do produto">
                </a>
                <div class="produto__nome-mobile">
                    <a href="${prod.url}" class="produto__nome">${prod.name}</a>
                    <p class="produto__sku">Cod. ${prod.sku}</p>
                    ${vars}
                </div>
                <div class="itemCar__especificacoes">
                    <a href="${prod.url}" class="produto__nome">${prod.name}</a>
                    <p class="produto__sku">Cod. ${prod.sku}</p>
                    ${vars}
                    <div class="itemCar__infos">
                        <div class="produtoDetalhes">
                            <p class="qtd__mobile">Quantidade:</p>
                            <div class="quantidadeProduto">
                                <div class="quantidadeProdutos-container">
                                    <p class="qtd__desktop">Quantidade</p>
                                    ${qtyHtml}
                                    <div class="lixeira">
                                        <div class="iconLixeira">
                                            <div class="iconLixeira__over"></div>
                                            <span data-wsjs-icon="delete"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="produtoPrecos__valores">
                                    ${priceHtml}
                                </div>
                            </div>
                            ${giftPackEl}
                            ${cashBackEl}
                        </div>
                    </div>
                </div>
            </div>`;
                }).join('');

                container.innerHTML = `
    <h2>Itens do carrinho</h2>
    ${productsStr}
    <div class="optionsButtonItensCar">
        <span class="optionButtonContinuaCompra ButtonOptionsCar">Continuar comprando</span>
        <span class="optionButtonLimpar ButtonOptionsCar">Limpar carrinho</span>
        <span class="optionButtonCompartilhar ButtonOptionsCar">Compartilhar</span>
    </div>`;

                container.querySelectorAll('.itemCar').forEach(el => {
                    if (el.getAttribute('storeGift') === 'true') return;
                    ff.updateSingleProductsPrice(el, el.getAttribute('prod-price'));
                });

                // Checkboxes de embalagem para presente
                container.querySelectorAll('.presenteOption input[type="checkbox"].embrulhar').forEach(input => {
                    input.addEventListener('change', async (e) => {
                        const itemEl = e.target.closest('.itemCar[itemId]');
                        if (!itemEl) return;
                        const itemId = itemEl.getAttribute('itemId');
                        const productId = itemEl.getAttribute('productId');
                        const status = e.target.checked;
                        try {
                            await ApiWS.Calls.cartItemSetGiftpack({ itemId, productId, status });
                            await wsMain.modules['checkout-cart2'].subFunctions.refreshAndRender();
                        } catch (err) {
                            console.error('[checkout-cart2] cartItemSetGiftpack:', err);
                            e.target.checked = !status; // reverte o checkbox em caso de erro
                        }
                    });
                });
            },

            createMobileResumeInfos() {
                const floatResume = document.querySelector('.float-resume');
                if (!floatResume) return;

                const prodsLabel = document.querySelector('#ws-carrinhoNovo .resumo .totalProdutos .resumoItem__titulo');
                if (prodsLabel) floatResume.querySelector('.float-resume__infos__produtos__label').innerHTML = prodsLabel.innerHTML;

                const prodsPrice = document.querySelector('#ws-carrinhoNovo .resumo .totalProdutos .resumoItem__promo');
                if (prodsPrice) floatResume.querySelector('.float-resume__infos__produtos__preco').innerHTML = prodsPrice.innerHTML;

                const totalEl = document.querySelector('#ws-carrinhoNovo .resumo .resumoItemTotal .totalPedido');
                if (totalEl) floatResume.querySelector('.float-resume-prices p.float-resume-price__total__price').innerHTML = totalEl.innerHTML;

                const shippingLabel = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .calcular');
                const shippingMobile = floatResume.querySelector('.float-resume__infos__frete__preco');
                if (shippingLabel && shippingMobile) {
                    if (shippingLabel.innerHTML === 'Calcular') shippingMobile.classList.add('uncalculated');
                    else shippingMobile.classList.remove('uncalculated');
                    shippingMobile.innerHTML = shippingLabel.innerHTML;
                }
            },

            createResumeInfos(data) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const sf = wsMain.modules['checkout-cart2'].subFunctions;

                ff.cartPrices.shipping = 0;

                ff.cartPrices.productTotal = Number(data.total || 0);
                ff.cartPrices.cashDiscount = Number(data.cash_discount || 0);
                ff.cartPrices.cashDiscountEligibleTotal = ff.getCashDiscountEligibleTotal(data);

                const realPriceLabel = document.querySelector('#ws-carrinhoNovo .resumo .totalProdutos .resumoItem__promo');
                const origPriceLabel = document.querySelector('#ws-carrinhoNovo .resumo .totalProdutos .resumoItem__preco');
                const discountLabel = document.querySelector('#ws-carrinhoNovo .resumo .descontoCalculado');
                if (!realPriceLabel || !origPriceLabel || !discountLabel) return;

                origPriceLabel.style.display = 'none';

                const subTotal = typeof data.subtotal === 'string' ? Number(data.subtotal.replace(',', '.')) : data.subtotal;
                realPriceLabel.innerHTML = ff.formatPrices.format(subTotal);

                // data.discount já SOMA o desconto do cupom (ex.: cupom de R$18 →
                // discount:18 + cupom.amount:18). O cupom tem linha própria
                // (.validCupomDiscount), então aqui só entra o que sobra — senão,
                // ao recarregar a página com cupom, o mesmo valor aparecia 2x.
                const discountTotal = typeof data.discount === 'string' ? Number(data.discount.replace(',', '.')) : Number(data.discount || 0);
                const couponAmount = data.cupom?.code ? (Number(data.cupom.amount) || 0) : 0;
                const otherDiscount = Math.round((discountTotal - couponAmount) * 100) / 100;
                if (!(otherDiscount > 0)) {
                    discountLabel.style.display = 'none';
                } else {
                    discountLabel.style.display = '';
                    discountLabel.querySelector('p:last-child').innerHTML = `- ${ff.formatPrices.format(otherDiscount)}`;
                }

                const totalLabel = document.querySelector('#ws-carrinhoNovo .resumo .resumoItemTotal .totalPedido');
                if (totalLabel) totalLabel.innerHTML = ff.formatPrices.format(data.total);

                try {
                    const descount1XEl = document.querySelector('#ws-carrinhoNovo .resumo .resumoItem.descontoem1x');
                    if (_wsCart1XDescount && descount1XEl) {
                        const pct = Number(_wsCart1XDescount);
                        descount1XEl.style.display = '';
                        const ship = ff.cartPrices.shipping > 0 ? ff.cartPrices.shipping : 0;
                        const base = ship > 0 ? (Number(data.total) - ship) : Number(data.total);
                        const total1x = (base * ((100 - pct) / 100)) + ship;
                        descount1XEl.innerHTML = `<p>1X de ${ff.formatPrices.format(total1x)} <span class="discount">-${pct}%</span></p>`;
                    } else if (descount1XEl) {
                        descount1XEl.style.display = 'none';
                    }
                } catch (e) {}

                try {
                    const installmentsEl = document.querySelector('#ws-carrinhoNovo .resumoItem.parcelas');
                    if (installmentsEl) {
                        const installment = sf.getInstallment(data.total, data.installments_min_value, data.max_installments);
                        if (installment && data.max_installments_no_interest > 1) {
                            let price = wsMain.data.compostFeeValue(data.installments_interest, data.max_installments_no_interest, data.max_installments_no_interest + 1, data.total);
                            if (price < data.installments_min_value) {
                                price = wsMain.data.compostFeeValue(data.installments_interest, installment, data.max_installments_no_interest + 1, data.total);
                                installmentsEl.innerHTML = `<p>em at&eacute; ${installment}x sem juros de ${wsMain.data.treatPrice(price)}</p>`;
                            } else {
                                installmentsEl.innerHTML = `<p>em at&eacute; ${data.max_installments_no_interest}x sem juros de ${wsMain.data.treatPrice(price)}</p>`;
                            }
                        } else {
                            installmentsEl.style.display = 'none';
                        }
                    }
                } catch (e) {}

                // cashback
                const sectionCashback = document.querySelector('[ws-cart-app="ws-cashback"]');
                const usarCashback = document.querySelector('#ws-carrinhoNovo .resumo .usar-cashback');
                const inserirCupom = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom');

                // reposiciona o cashback para logo acima dos botões (Continuar comprando / Limpar carrinho / Compartilhar)
                const cartActionButtons = document.querySelector('#ws-carrinhoNovo .checkout-content .itensCarrinho .optionsButtonItensCar');
                if (sectionCashback && cartActionButtons && cartActionButtons.previousElementSibling !== sectionCashback) {
                    cartActionButtons.insertAdjacentElement('beforebegin', sectionCashback);
                }

                if (data.cashback?.valor > 0) {
                    const logged = document.querySelector('#HD_LVCLI_ID')?.value || localStorage.getItem('ws_customer_session');
                    if (logged && data.cashback.saldo == 0) {
                        if (usarCashback) usarCashback.style.display = 'none';
                        if (inserirCupom) inserirCupom.classList.add('resume-bottom-border');
                    }
                    if (logged && data.cashback.saldo > 0) {
                        document.querySelector('#ws-carrinhoNovo .resumo .usar-cashback .usar-cashback__login')?.style.setProperty('display', 'none');
                        const useCb = document.querySelector('#ws-carrinhoNovo .resumo .usar-cashback .usar-cashback__use-cashback');
                        if (useCb) {
                            useCb.querySelector('.cashback-value').innerHTML = ff.formatPrices.format(data.cashback.saldo);
                            useCb.style.display = '';
                        }
                    }
                    sectionCashback?.querySelector('.cashback-app__infos__msg > span')
                        && (sectionCashback.querySelector('.cashback-app__infos__msg > span').innerHTML = `Ganhe ${ff.formatPrices.format(data.cashback.valor)} de cashback`);
                } else {
                    if (usarCashback) usarCashback.style.display = 'none';
                    if (sectionCashback) sectionCashback.style.display = 'none';
                    if (inserirCupom) inserirCupom.classList.add('resume-bottom-border');
                }

                // pix/boleto discount
                const pixBoletoEl = document.querySelector('#ws-carrinhoNovo .resumoItem.pixBoleto');
                const discountTag = pixBoletoEl?.querySelector('.discount');
                const pixTotalLabel = pixBoletoEl?.querySelector('.totalPedido');
                const pixMsg = pixBoletoEl?.querySelector('.pixBoleto__msg');
                if (data.cash_discount > 0 && pixBoletoEl) {
                    pixBoletoEl.style.display = '';
                    if (pixMsg) pixMsg.innerHTML = _wsCartFinishBoletoPixMsg;
                    if (discountTag) discountTag.innerHTML = `-${data.cash_discount}%`;
                    if (pixTotalLabel) pixTotalLabel.innerHTML = `ou ${ff.createBoletoPixDiscount()}`;
                } else if (pixBoletoEl) {
                    pixBoletoEl.style.display = 'none';
                    if (pixTotalLabel) pixTotalLabel.innerHTML = ff.formatPrices.format(data.total);
                }

                // shipping already selected in cart data
                if (data.shipping?.selected) {
                    const calcLabel = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .calcular');
                    if (calcLabel) {
                        calcLabel.classList.remove('uncalculated');
                        if (data.shipping.isFree) {
                            calcLabel.innerHTML = 'Gr&aacute;tis';
                        } else if (data.shipping.price > 0) {
                            const shippingVal = Number(data.shipping.price);
                            calcLabel.innerHTML = ff.formatPrices.format(shippingVal);
                            ff.cartPrices.shipping = shippingVal;
                        }
                        if (data.shipping.discount > 0) {
                            const discountResume = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .shipping-discount-resume');
                            if (discountResume) {
                                discountResume.style.display = '';
                                discountResume.innerHTML = ff.formatPrices.format(Number(data.shipping.discount));
                            }
                        }
                    }
                }

                ff.cartPrices.productTotal = Number(data.total) - ff.cartPrices.shipping;
                ff.recalcTotals();

                // Cupom já gravado no carrinho: só pinta o estado (linha do cupom +
                // "Remover cupom") a partir do /cart/view — não reaplica via
                // /cart/coupon/apply a cada carregamento.
                if (data.cupom?.code) {
                    ff.renderAppliedCoupon(data.cupom.name || data.cupom.code, ff.formatPrices.format(Number(data.cupom.amount) || 0));
                }

                wsMain.modules['checkout-cart2'].observer(null, data);
            },

            createBoletoPixDiscount() {
                try {
                    const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                    const base = Math.max(0, Number(ff.cartPrices.productTotal || 0));
                    const ship = ff.cartPrices.shipping > 0 ? ff.cartPrices.shipping : 0;
                    const eligible = Math.min(base, Number(ff.cartPrices.cashDiscountEligibleTotal || 0));
                    const pct = Number(ff.cartPrices.cashDiscount || 0);
                    if (!pct || pct <= 0 || !eligible || eligible <= 0) return ff.formatPrices.format(base + ship);
                    return ff.formatPrices.format(base - (eligible * (pct / 100)) + ship);
                } catch (e) {
                    return wsMain.modules['checkout-cart2'].factoryFunctions.formatPrices.format(0);
                }
            },

            // :not(.ws-checkout-init-btn-finish) nas 3 buscas por
            // '#ws-carrinhoNovo .buttonFinalizar:not(.ws-checkout-init-btn-finish)' abaixo: #ws-carrinhoNovo
            // envolve o checkout INTEIRO (não só a etapa carrinho — este
            // módulo roda em FinalPagamento/FORMAS_PAGAMENTO também), e o
            // botão "Finalizar compra" da tela de pagamento
            // (wsapi3-checkout-payment-page, #ws-checkout-init-btn-finish)
            // usa a MESMA classe .buttonFinalizar só pra herdar o visual
            // verde — sem essa exclusão, createButtonMsg() insere um
            // <span class="buttonFinalizar__msg"> DENTRO dele, duplicando o
            // texto por cima do <span id="ws-checkout-init-finish-label">
            // que já existe ali.
            updateFinishButton(go) {
                document.querySelectorAll('#ws-carrinhoNovo .buttonFinalizar:not(.ws-checkout-init-btn-finish)').forEach(btn => {
                    const loader = btn.querySelector('.carrinhoLoader-container');
                    const msg = btn.querySelector('span');
                    if (go) {
                        btn.classList.remove('finishNotReady');
                        loader?.classList.add('loaderOff');
                        if (msg) msg.style.display = 'block';
                    } else {
                        btn.classList.add('finishNotReady');
                        loader?.classList.remove('loaderOff');
                        if (msg) msg.style.display = 'none';
                    }
                });
            },

            createButtonMsg() {
                try {
                    document.querySelectorAll('#ws-carrinhoNovo .buttonFinalizar:not(.ws-checkout-init-btn-finish)').forEach(btn => {
                        if (btn.querySelector('.buttonFinalizar__msg')) return;
                        const span = document.createElement('span');
                        span.className = 'buttonFinalizar__msg';
                        span.innerHTML = _wsCartFinishButtonLabel;
                        btn.insertBefore(span, btn.querySelector('.carrinhoLoader-container'));
                    });
                } catch (e) {}
            },

            updateSingleProductsPrice(prod, price) {
                try {
                    if (!prod || !price) return;
                    const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                    const qtd = prod.querySelector('.quantidadeProdutos__btns__qnt')?.value;
                    const priceEl = prod.querySelector('.quantidadeProduto .valores__desconto');
                    const priceUnEl = prod.querySelector('.quantidadeProduto .valores__desconto__un');
                    if (!qtd || !priceEl) return;
                    if (priceUnEl) priceUnEl.style.display = qtd > 1 ? '' : 'none';
                    priceEl.innerHTML = ff.formatPrices.format(Number(price) * Number(qtd));
                } catch (e) {}
            },

            linkToShare: '',
            linkToShareParams: {},

            updateShareLink(param, value) {
                if (param && value) wsMain.modules['checkout-cart2'].factoryFunctions.linkToShareParams[param] = value;
            },

            createShareLink() {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const params = Object.entries(ff.linkToShareParams).map(([k, v]) => `&${k}=${v}`).join('');
                return `${ff.linkToShare}${params}`;
            },

            createSharePopup(cartToken) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const obfKey = 'kwkbhbvdsojiqwdojr3279tu3qpjawjnvsdjndwopjqwdoh2h9109ejnefj';
                const shareParam = cartToken ? `${obfKey}${cartToken}${obfKey}` : '';
                ff.linkToShare = `${window.location.protocol}//${window.location.host}/carrinho?share_cart=${shareParam}`;

                const btn = document.querySelector('#ws-carrinhoNovo .optionButtonCompartilhar');
                if (!btn) return;

                btn.addEventListener('click', () => {
                    ff.updateUserMessage(ff.createShareLink(), 'Compartilhe seu carrinho', 'share', true);
                });
            },

            createMessageToUser() {
                if (document.querySelector('#msg-to-user')) return;
                const clone = document.querySelector('#product-popup')?.cloneNode(true);
                if (!clone) return;
                clone.id = 'msg-to-user';
                clone.classList.add('popupHidden');
                clone.querySelector('.removerConfirmacao__popup__btns')?.remove();
                document.querySelector('#ws-carrinhoNovo')?.appendChild(clone);
                document.querySelector('#msg-to-user .removerConfirmacao__popup__fechar')
                    ?.addEventListener('click', () => clone.classList.add('popupHidden'));
            },

            updateUserMessage(msg, title, attr = 'default', copy = false) {
                const container = document.querySelector('#msg-to-user');
                if (!container) return;

                container.dataset.messageType = attr;
                const titleEl = container.querySelector('.removerConfirmacao__popup__title');
                const subtitle = container.querySelector('.removerConfirmacao__popup__subTitle');

                if (typeof msg === 'object') { if (!msg.message) return; msg = msg.message; }
                if (titleEl) titleEl.innerHTML = title || 'Alerta';

                if (copy) {
                    const copyIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#333333"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>`;
                    const checkSvg = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#333333"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>`;
                    const whatsappIcon = wsMain.globalData?.icons?.whatsapp || `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24"><path fill="#25D366" d="M16 3C9 3 3 9 3 16c0 2.3.6 4.5 1.8 6.4L3 29l6.8-1.8A13 13 0 0 0 16 29c7 0 13-6 13-13S23 3 16 3zm6.3 18.3c-.3.8-1.5 1.5-2 1.6-.6.1-1.1.1-1.6 0-.5-.1-1.1-.3-1.9-.7-3.3-1.4-5.4-4.8-5.6-5-.2-.2-1.3-1.7-1.3-3.3 0-1.6.8-2.4 1.1-2.7.3-.3.6-.4.9-.4h.6c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .6l-.5.6-.3.4c.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.4 2.4 1.5.3.1.5 0 .6-.1l.8-.9c.2-.2.4-.2.6-.1l2 .9c.2.1.4.2.4.4v.8z"/></svg>`;

                    subtitle.innerHTML = `
                        <input type="text" disabled value="${msg}">
                        <div class="shareButtons">
                            <div class="copy-icon">
                                <div class="copy-overlay" title="Copiar URL" copy-type="onlyCopy"></div>
                                <div class="svg-container">${copyIconSvg}</div>
                                <span>Copiar URL</span>
                            </div>
                            <div class="copy-icon">
                                <a class="copy-overlay" title="Compartilhar no Whatsapp" target="_blank" copy-type="whatsapp"></a>
                                ${whatsappIcon}
                                <span>WhatsApp</span>
                            </div>
                        </div>`;

                    subtitle.querySelectorAll('.copy-overlay').forEach(el => {
                        el.addEventListener('click', e => {
                            const type = el.getAttribute('copy-type');
                            const txt = subtitle.querySelector('input').value;
                            if (type === 'whatsapp') {
                                el.href = `whatsapp://send?text=Veja o carrinho que montei para você. ${encodeURIComponent(txt)}`;
                                return;
                            }
                            navigator.clipboard.writeText(txt);
                            const spanEl = el.parentNode.querySelector('span');
                            const svgEl = el.parentNode.querySelector('.svg-container');
                            spanEl.innerHTML = 'Link copiado';
                            svgEl.innerHTML = checkSvg;
                            setTimeout(() => {
                                if (spanEl.innerHTML === 'Link copiado') {
                                    spanEl.innerHTML = 'Copiar URL';
                                    svgEl.innerHTML = copyIconSvg;
                                }
                            }, 5000);
                        });
                    });
                } else {
                    subtitle.innerHTML = msg;
                }

                container.classList.remove('popupHidden');
            },

            // Linha "Cupom" do resumo + campo fechado com "Remover cupom". Usado
            // tanto logo após aplicar quanto no load (cupom vindo do /cart/view).
            renderAppliedCoupon(title, valueLabel) {
                const cupomDiscount = document.querySelector('#ws-carrinhoNovo .resumo .validCupomDiscount');
                if (cupomDiscount) {
                    cupomDiscount.querySelector('.validCupomDiscount__title').innerHTML = title || 'Cupom';
                    cupomDiscount.querySelector('.validCupomDiscount__value').innerHTML = `- ${valueLabel}`;
                    cupomDiscount.style.display = '';
                }
                const checkbox = document.querySelector('#ws-carrinhoNovo #inserirCupom');
                if (checkbox) checkbox.checked = false;
                const cupomLabel = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom > label');
                if (cupomLabel) {
                    cupomLabel.removeAttribute('for');
                    cupomLabel.innerHTML = 'Remover cupom';
                    cupomLabel.dataset.cart2RemoveCoupon = '1';
                }
                document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom .errorMsgCupom')?.classList.add('hiddenMessageCupom');
            },

            async applyCoupon(couponCode) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const cupomInput    = document.querySelector('#ws-carrinhoNovo #cupomParaEnviar');
                const cupomBtn      = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom .buttonInserirCupom');
                const cupomLoader   = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom .carrinhoLoader-container');
                const cupomError    = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom .errorMsgCupom');

                const setLoading = (on) => {
                    if (on) {
                        cupomBtn?.style.setProperty('display', 'none');
                        cupomLoader?.classList.replace('loaderOff', 'loaderOn');
                    } else {
                        cupomBtn?.style.setProperty('display', '');
                        cupomLoader?.classList.replace('loaderOn', 'loaderOff');
                    }
                };

                if (!couponCode?.trim()) {
                    if (cupomError) { cupomError.innerHTML = 'Digite o código do cupom.'; cupomError.classList.remove('hiddenMessageCupom'); }
                    return;
                }

                setLoading(true);
                if (cupomError) cupomError.classList.add('hiddenMessageCupom');

                try {
                    const result = await ApiWS.Calls.cartCouponApply(couponCode.trim());

                    if (result?.result === 'success' && result?.record) {
                        const rec = result.record;

                        // Mostra bloco de desconto do cupom no resumo
                        ff.renderAppliedCoupon(rec.coupon_title || rec.coupon_code || 'Cupom',
                            rec.discount_label || ff.formatPrices.format(rec.discount_amount));

                        // Atualiza total
                        if (rec.new_total !== undefined) {
                            ff.cartPrices.productTotal = Number(rec.new_total) - ff.cartPrices.shipping;
                            ff.recalcTotals();
                        }
                        if (cupomInput) cupomInput.value = '';
                    } else {
                        const msg = ApiWS.Calls.cartCouponErrorHtml(result);
                        if (cupomError) { cupomError.innerHTML = msg; cupomError.classList.remove('hiddenMessageCupom'); }
                    }
                } catch (e) {
                    console.error('[checkout-cart2] applyCoupon:', e);
                    if (cupomError) { cupomError.innerHTML = 'Erro ao aplicar cupom.'; cupomError.classList.remove('hiddenMessageCupom'); }
                } finally {
                    setLoading(false);
                }
            },

            openCleanCartConfirm() {
                const popup = document.querySelector('#product-popup');
                if (!popup) return;

                wsMain.modules['checkout-cart2'].subFunctions.changePopupMessage(
                    'Limpar Carrinho', 'Voc&ecirc; deseja limpar o carrinho?', 'Sim'
                );
                popup.classList.remove('popupHidden');

                const removeBtn = popup.querySelector('.removerConfirmacao__btn__remover');
                const cancelBtn = popup.querySelector('.removerConfirmacao__btn__cancelar');
                const closeBtn = popup.querySelector('.removerConfirmacao__popup__fechar');

                const cleanup = () => popup.classList.add('popupHidden');
                const doClean = async () => {
                    cleanup();
                    localStorage.removeItem('orderIdKeepTC_B');
                    await ApiWS.Calls.cartStart();
                    window.location.reload();
                };

                removeBtn?.addEventListener('click', doClean, { once: true });
                cancelBtn?.addEventListener('click', cleanup, { once: true });
                closeBtn?.addEventListener('click', cleanup, { once: true });
            },

            // Linha (label + rádio) de uma forma de envio. opts.name/opts.id: no
            // Multi CD cada pacote tem o seu grupo de rádios (freight_{cd_id}).
            freightOptionHtml(elm, opts = {}) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const inputName = opts.name || 'freight';
                const inputId = opts.id || `method_${elm.id}`;
                const checked = elm.selected ? 'checked' : '';
                const priceLabel = elm.is_free ? 'Gr&aacute;tis' : (elm.price_display || ff.formatPrices.format(elm.price));

                let deadline = elm.deadline_display || '';
                if (!deadline) {
                    if (elm.deadline > 1) deadline = `${elm.deadline} dias &uacute;teis`;
                    else if (elm.deadline === 1) deadline = `${elm.deadline} dia &uacute;til`;
                    else if (elm.deadline === 0 && elm.name.toLowerCase() !== 'a combinar') deadline = 'Hoje';
                }

                const discountHtml = elm.discount > 0
                    ? `<span class="shipping-priceDiscount">${ff.formatPrices.format(elm.price + elm.discount)}</span> `
                    : '';
                const isACombinar = elm.name.toLowerCase() === 'a combinar';

                return `
                <label class="opcoes lbl_shipping_method_${elm.id}">
                    <input type="radio" id="${inputId}" name="${inputName}"
                        shipping-value="${elm.price}" shipping-discount="${elm.discount}" ${checked}>
                    <div for="${elm.id}">
                        <span>${elm.name}</span>
                        <span class="expectativeTempo" style="${isACombinar ? 'display:none' : ''}">
                            ${deadline}${deadline ? ' - ' : ''}${discountHtml}<span class="fullprice-shipping">${priceLabel}</span>
                        </span>
                    </div>
                </label>`;
            },

            createFreightLabel(records, zipcode) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const container = document.querySelector('#ws-carrinhoNovo .frete .freteOpcoes');
                if (!container) return;

                // zipcode pode vir do calcularFrete; fallback para o localStorage
                const resolvedZip = (zipcode || localStorage.getItem('CEP_CART_KEEP') || '').replace(/\D/g, '');

                document.querySelector('#ws-carrinhoNovo .errorMsgFrete')?.style.setProperty('display', 'none');

                const shippingHtml = records.map(elm => ff.freightOptionHtml(elm)).join('');

                container.innerHTML = shippingHtml;

                const selectShipping = (rec) => {
                    ff.updateResumeShipping(rec);
                    ApiWS.Analytics?.addShippingInfo(window.cartJson?.products, window.cartJson?.subtotal, rec.name);
                    ApiWS.Calls.cartShippingSelect({
                        shippingId: rec.id,
                        shippingName: rec.name,
                        shippingPrice: rec.price,
                        shippingDiscount: rec.discount,
                        shippingDeadline: rec.deadline,
                        zipcode: resolvedZip,
                        scheduling: rec.scheduling || '',
                    })
                        // Gatilhos legados pós-seleção de frete (ver ApiWS.LegacyHooks)
                        .then(() => ApiWS.LegacyHooks.shippingSelected({ zipcode: resolvedZip, option: rec }))
                        .catch(e => console.error('[checkout-cart2] cartShippingSelect:', e));
                };

                // Seleciona automaticamente a opção pré-marcada pela API
                const pre = records.find(r => r.selected);
                if (pre) selectShipping(pre);

                // Bind: ao trocar opção, atualiza resumo e persiste no backend
                container.querySelectorAll('input[name="freight"]').forEach(input => {
                    input.addEventListener('change', () => {
                        const id = input.id.replace('method_', '');
                        const rec = records.find(r => r.id == id);
                        if (rec) selectShipping(rec);
                    });
                });

                wsMain.modules['checkout-cart2'].subFunctions.setFreteLoading(false);
                ff.createMobileResumeInfos();
            },

            /* Multi CD (ApiWS.MultiCd, wsapi3-wsjs): um bloco por pacote/CD,
               cada um com o seu grupo de rádios. A pré-seleção da API (selected
               em cada pacote) é gravada na hora, um /cart/shipping/select por
               cd_id — mesmo comportamento do carrinho comum (selectShipping(pre)).
               O resumo mostra a soma dos pacotes. */
            async createFreightLabelMultiCd(parsed, zipcode) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const sf = wsMain.modules['checkout-cart2'].subFunctions;
                const container = document.querySelector('#ws-carrinhoNovo .frete .freteOpcoes');
                if (!container) return;

                const session = ApiWS.MultiCd.session(parsed, { zipcode });
                sf._multiCd = session;
                ApiWS.MultiCd.remember(parsed, localStorage['orderIdKeepTC_B']);

                const draw = () => {
                    container.innerHTML = '';
                    ApiWS.MultiCd.render(container, parsed, {
                        products: window.cartJson?.products,
                        session,
                        renderOption: (opt, group) => {
                            const tpl = document.createElement('template');
                            tpl.innerHTML = ff.freightOptionHtml({ ...opt, selected: false }, {
                                name: `freight_${group.cdId}`,
                                id: `method_${group.cdId}_${opt.id}`,
                            }).trim();
                            return tpl.content.firstElementChild;
                        },
                        setSelected: (row, on) => { const r = row.querySelector('input'); if (r) r.checked = on; },
                        onSelect: (group, opt) => ff.selectShippingMultiCd(group, opt),
                    });
                };
                session._draw = draw;
                draw();
                sf.setFreteLoading(false);

                const block = ApiWS.MultiCd.blockReason(parsed);
                if (block) {
                    ff.updateResumeMultiCd();
                    ff.showFreteError(block);
                    return;
                }
                try {
                    const r = await session.selectPreselected();
                    if (r?.result !== 'success') { ff.multiCdError(r); return; }
                } catch (e) {
                    console.error('[checkout-cart2] multiCd preselect:', e);
                }
                draw();
                ff.updateResumeMultiCd();
            },

            async selectShippingMultiCd(group, opt) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const session = wsMain.modules['checkout-cart2'].subFunctions._multiCd;
                if (!session) return;
                document.querySelector('#ws-carrinhoNovo .errorMsgFrete')?.style.setProperty('display', 'none');
                try {
                    const r = await session.select(group, opt);
                    if (r?.result !== 'success') { ff.multiCdError(r); return; }
                    ff.updateResumeMultiCd();
                    if (session.isComplete()) {
                        ApiWS.Analytics?.addShippingInfo(window.cartJson?.products, window.cartJson?.subtotal, session.summary().name);
                    }
                    ApiWS.LegacyHooks.shippingSelected({ zipcode: session.zipcode, option: opt });
                } catch (e) {
                    console.error('[checkout-cart2] selectShippingMultiCd:', e);
                    session._draw?.();
                    ff.showFreteError('N&atilde;o foi poss&iacute;vel selecionar este frete.');
                }
            },

            // Resumo "Frete": soma das escolhas; "Calcular" enquanto falta pacote.
            updateResumeMultiCd() {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const session = wsMain.modules['checkout-cart2'].subFunctions._multiCd;
                if (!session || !session.isComplete()) {
                    ff.cartPrices.shipping = 0;
                    const calcLabel = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .calcular');
                    if (calcLabel) { calcLabel.innerHTML = 'Calcular'; calcLabel.classList.add('uncalculated'); }
                    const discountResume = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .shipping-discount-resume');
                    if (discountResume) discountResume.style.display = 'none';
                    ff.recalcTotals();
                    return;
                }
                const sum = session.summary();
                ff.updateResumeShipping({ name: sum.name || 'Frete', price: sum.price, discount: sum.discount, is_free: sum.free });
            },

            // Erro de select/close Multi CD: alocação mudou → mensagem + novo
            // cálculo (no máx. 1x a cada 5s); outro erro → só a mensagem.
            multiCdError(r) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const sf = wsMain.modules['checkout-cart2'].subFunctions;
                const text = r?.message || 'N&atilde;o foi poss&iacute;vel selecionar este frete.';
                if (ApiWS.MultiCd.needsRecalc(r) && Date.now() - (sf._multiCdRecalcAt || 0) > 5000) {
                    sf._multiCdRecalcAt = Date.now();
                    sf.recalcFreteMultiCd(text);
                    return;
                }
                sf._multiCd?._draw?.();
                ff.showFreteError(text);
            },

            updateResumeShipping(record) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const calcLabel = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .calcular');
                if (!calcLabel) return;

                calcLabel.classList.remove('uncalculated');

                if (record.is_free || (!record.price && record.name.toLowerCase() !== 'a combinar')) {
                    calcLabel.innerHTML = 'Gr&aacute;tis';
                    ff.cartPrices.shipping = 0;
                } else if (record.name.toLowerCase() === 'a combinar') {
                    calcLabel.innerHTML = 'A combinar';
                    ff.cartPrices.shipping = 0;
                } else {
                    calcLabel.innerHTML = record.price_display || ff.formatPrices.format(record.price);
                    ff.cartPrices.shipping = Number(record.price);
                }

                const discountResume = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .shipping-discount-resume');
                if (discountResume) {
                    if (record.discount > 0) {
                        discountResume.style.display = '';
                        discountResume.innerHTML = ff.formatPrices.format(record.discount);
                    } else {
                        discountResume.style.display = 'none';
                    }
                }

                ff.recalcTotals();
            },

            showFreteError(msg) {
                const errEl = document.querySelector('#ws-carrinhoNovo .errorMsgFrete');
                if (errEl) { errEl.innerHTML = msg; errEl.style.display = 'flex'; }
                wsMain.modules['checkout-cart2'].subFunctions.setFreteLoading(false);
            },

            recalcTotals() {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const total = (ff.cartPrices.productTotal || 0) + (ff.cartPrices.shipping || 0);
                const totalLabel = document.querySelector('#ws-carrinhoNovo .resumo .resumoItemTotal .totalPedido');
                if (totalLabel) totalLabel.innerHTML = ff.formatPrices.format(total);
                const pixTotalLabel = document.querySelector('#ws-carrinhoNovo .resumoItem.pixBoleto .totalPedido');
                if (pixTotalLabel) pixTotalLabel.innerHTML = `ou ${ff.createBoletoPixDiscount()}`;
                ff.createMobileResumeInfos();
            },

            resetShippingState() {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                ff.cartPrices.shipping = 0;
                const calcLabel = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .calcular');
                if (calcLabel) { calcLabel.innerHTML = 'Calcular'; calcLabel.classList.add('uncalculated'); }
                const freteOpcoes = document.querySelector('#ws-carrinhoNovo .frete .freteOpcoes');
                if (freteOpcoes) freteOpcoes.innerHTML = '';
                const discountResume = document.querySelector('#ws-carrinhoNovo .resumo .taxaEntrega .shipping-discount-resume');
                if (discountResume) discountResume.style.display = 'none';
                ff.recalcTotals();
            },

            // Template próprio — antes vinha da global "htmlfretegratisalert"
            // do app nativo AlertaFreteGratis, que agora é suspenso quando
            // window.WsApi3Apps.freteGratis === true (ver wsapi3-apps module
            // e o guard adicionado no app nativo). O CSS .frtalert-* continua
            // vindo do app (só o JS foi suspenso), por isso o template abaixo
            // mantém as mesmas classes.
            freteGratisTemplate: `<div class="frtalert-quadro">
                <div class="frtalert-texto">Faltam apenas <span>R$ {FaltaX}</span> para voc&ecirc; ganhar frete gr&aacute;tis</div>
                <div class="frtalert-barra-container">
                    <div class="frtalert-barra">
                        <div class="frtalert-barra-azul" data-percent="{FaltaPercent}" style="width:0%">
                            <div class="frtalert-caminhao-container">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18.423" height="15.039" viewBox="0 0 18.423 15.039">
                                    <path d="M972.154,6420.539h1.978a1.668,1.668,0,0,1,.408.025.668.668,0,0,1,.245.1,1.826,1.826,0,0,1,.306.271l3.437,3.435a1.774,1.774,0,0,1,.272.305.878.878,0,0,1,.1.245,1.81,1.81,0,0,1,.024.406v2.4a2.074,2.074,0,0,1-.064.744.827.827,0,0,1-.458.457,2.01,2.01,0,0,1-.747.068m-4.231,0h-1.269m0,0v-8.292a4.221,4.221,0,0,0-.184-1.786,1.709,1.709,0,0,0-.74-.736,4.162,4.162,0,0,0-1.784-.187h-4.739a4.162,4.162,0,0,0-1.784.187,1.709,1.709,0,0,0-.74.736,4.221,4.221,0,0,0-.184,1.786v6.6a1.7,1.7,0,0,0,1.692,1.692m8.462,0h-3.385m0,0a2.539,2.539,0,1,1-5.077,0m5.077,0a2.539,2.539,0,1,0-5.077,0m13.962.423a2.115,2.115,0,1,1-2.115-2.115A2.116,2.116,0,0,1,977.654,6429.423Z" transform="translate(-961.25 -6417.25)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <p class="frtalert-texto-barra">Frete gr&aacute;tis</p>
                </div>
            </div>`,

            // Regras + localização: ApiWS.FreeShipping (wsapi3-wsjs), mesma avaliação
            // do carrinho lateral. regional = região ainda não confirmada → nunca
            // promete "será grátis" e, atingido o valor, mostra só o aviso, sem barra.
            async renderFreteGratisAlert(total, shipping) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                let info = null;
                try { info = await ApiWS.FreeShipping.evaluate({ total, shipping }); }
                catch (e) { console.error('[checkout-cart2] FreeShipping.evaluate:', e); }
                if (!info) return;

                const percent = info.reached ? 101 : info.percent;
                const faltaFormatted = wsMain.data.treatPrice(info.missing).replace(/R\$\s?/, '');
                const html = ff.freteGratisTemplate
                    .replace('{FaltaX}', faltaFormatted)
                    .replace('{FaltaPercent}', percent)
                    .replace('frete gr&aacute;tis</div>', info.regional ? 'frete gr&aacute;tis em algumas regi&otilde;es</div>' : 'frete gr&aacute;tis</div>');

                // Âncoras dedicadas do layout (topo e rodapé)
                const anchors = [
                    ...document.querySelectorAll('[data-frete-grats-falta-x-vrsapp]'),
                    ...document.querySelectorAll('[data-frete-grats-falta-x-vrsapp-end]'),
                ];

                // Fallback: cria container próprio se não houver âncoras
                if (!anchors.length) {
                    let container = document.querySelector('[data-wsjs-frete-gratis]');
                    if (!container) {
                        container = document.createElement('div');
                        container.setAttribute('data-wsjs-frete-gratis', '');
                        const itensCarrinho = document.querySelector('#ws-carrinhoNovo .checkout-content .itensCarrinho');
                        if (itensCarrinho) itensCarrinho.insertAdjacentElement('beforebegin', container);
                        else document.querySelector('#ws-carrinhoNovo .checkout-content')?.prepend(container);
                    }
                    if (container.parentNode) anchors.push(container);
                }

                // Injeta e anima cada âncora individualmente
                anchors.forEach(anchor => {
                    anchor.innerHTML = html;
                    const bar = anchor.querySelector('.frtalert-barra-azul');
                    if (!bar) return;
                    bar.style.opacity = '1';
                    if (percent > 100 && info.regional) {
                        const texto = anchor.querySelector('.frtalert-texto');
                        if (texto) texto.innerHTML = 'Seu pedido pode ter <b>frete gr&aacute;tis</b> para algumas regi&otilde;es. Calcule o frete para confirmar.';
                        anchor.querySelector('.frtalert-barra-container')?.remove();
                    } else if (percent > 100) {
                        const texto = anchor.querySelector('.frtalert-texto');
                        const textoBar = anchor.querySelector('.frtalert-texto-barra');
                        if (texto) texto.innerHTML = '<b>A entrega desse pedido ser&aacute; gr&aacute;tis</b>';
                        if (textoBar) textoBar.innerHTML = '<b>Frete gr&aacute;tis</b>';
                        bar.style.width = '100%';
                    } else {
                        bar.style.width = `${Math.max(6, percent)}%`;
                    }
                });
            }
        },

        subFunctions: {
            getInstallment(price, min, i) {
                try {
                    if (!i || i <= 0) return 1;
                    if (price / i >= min) return i;
                    return wsMain.modules['checkout-cart2'].subFunctions.getInstallment(price, min, i - 1);
                } catch (e) { return 1; }
            },
            changeResumeTotalProductsLabel(newValue) {
                try {
                    const el = document.querySelector('#ws-carrinhoNovo .resumoItem__titulo');
                    if (el) el.innerHTML = `${newValue > 1 ? 'Produtos' : 'Produto'} (${newValue})`;
                } catch (e) {}
            },

            changePopupMessage(newTitle, newSubTitle, btnTitle) {
                try {
                    const popup = document.querySelector('#ws-carrinhoNovo #product-popup');
                    if (!popup) return;
                    if (newTitle) popup.querySelector('.removerConfirmacao__popup__title').innerHTML = newTitle;
                    if (newSubTitle) popup.querySelector('.removerConfirmacao__popup__subTitle').innerHTML = newSubTitle;
                    if (btnTitle) popup.querySelector('.removerConfirmacao__btn__remover').innerHTML = btnTitle;
                } catch (e) {}
            },

            setFreteLoading(active) {
                const loader = document.querySelector('#ws-carrinhoNovo .frete .cepInput__infos .carrinhoLoader-container');
                const btn = document.querySelector('#ws-carrinhoNovo .frete .cepInput__infos [loaders-type="btn"][btn-type="cep"]');
                if (active) {
                    loader?.classList.remove('loaderOff');
                    loader?.classList.add('loaderOn');
                    if (btn) btn.style.display = 'none';
                } else {
                    loader?.classList.remove('loaderOn');
                    loader?.classList.add('loaderOff');
                    if (btn) btn.style.display = '';
                }
            },

            async calcularFrete(zipcode) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const sf = wsMain.modules['checkout-cart2'].subFunctions;

                const clean = String(zipcode).replace(/\D/g, '');
                if (clean.length !== 8) {
                    ff.showFreteError('Preencha o CEP corretamente.');
                    return;
                }

                // Limpa opções anteriores e erros
                const opcoes = document.querySelector('#ws-carrinhoNovo .frete .freteOpcoes');
                if (opcoes) opcoes.innerHTML = '';
                document.querySelector('#ws-carrinhoNovo .errorMsgFrete')?.style.setProperty('display', 'none');

                sf.setFreteLoading(true);

                try {
                    const result = await ApiWS.Calls.cartShippingCalculate(clean);
                    const multiCd = result?.result === 'success' ? ApiWS.MultiCd.parse(result) : null;
                    sf._multiCd = null;

                    if (multiCd) {
                        localStorage.setItem('CEP_CART_KEEP', clean);
                        await ff.createFreightLabelMultiCd(multiCd, clean);
                        ApiWS.LegacyHooks.shippingCalculated({ zipcode: clean, options: multiCd.groups.flatMap(g => g.options) });
                    } else if (result?.result === 'success' && result?.records?.length) {
                        localStorage.setItem('CEP_CART_KEEP', clean);
                        ff.createFreightLabel(result.records, clean);
                        ApiWS.LegacyHooks.shippingCalculated({ zipcode: clean, options: result.records });
                    } else {
                        ff.showFreteError('Frete indispon&iacute;vel para esta regi&atilde;o.');
                    }
                } catch (e) {
                    console.error('[checkout-cart2] calcularFrete:', e);
                    ff.showFreteError('N&atilde;o foi poss&iacute;vel calcular o frete.');
                }
            },

            // Volta o cliente pro frete (Multi CD): recalcula com o CEP salvo e
            // mostra a mensagem (estoque/alocação mudou, pacote sem frete...).
            async recalcFreteMultiCd(message) {
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const sf = wsMain.modules['checkout-cart2'].subFunctions;
                sf._multiCd = null;
                const cepInput = document.querySelector('#ws-carrinhoNovo .frete .cepInput__infos input[cart-checkout-input="cep"]');
                const zip = String(cepInput?.value || localStorage.getItem('CEP_CART_KEEP') || '').replace(/\D/g, '');
                if (zip.length === 8) await sf.calcularFrete(zip);
                if (message) ff.showFreteError(message);
                document.querySelector('#ws-carrinhoNovo .frete')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            },

            async refreshAndRender() {
                try {
                    const fresh = await ApiWS.Calls.cartView();
                    if (fresh?.products !== undefined) {
                        window.cartJson = fresh;
                        await wsMain.modules['checkout-cart2'].create(fresh);
                    }
                } catch (e) { console.error('[checkout-cart2] refreshAndRender:', e); }
            },

            bindCartEvents(container) {
                if (!container || container.dataset.cart2Events) return;
                container.dataset.cart2Events = '1';

                const sf = wsMain.modules['checkout-cart2'].subFunctions;
                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;

                container.addEventListener('click', async function (e) {
                    const item = e.target.closest('.itemCar[itemId]');
                    if (!item || item.getAttribute('storeGift') === 'true') return;

                    const itemId = item.getAttribute('itemId');
                    const groupId = item.getAttribute('groupId') || '';
                    const qtyInput = item.querySelector('.quantidadeProdutos__btns__qnt');
                    const currentQty = Number(qtyInput?.value || 1);

                    if (e.target.closest('.quantidadeProdutos__btns__add')) {
                        e.preventDefault();
                        if (currentQty >= 999) return;
                        if (qtyInput) qtyInput.value = currentQty + 1;
                        const r = await ApiWS.Calls.cartItemUpdate({ itemId, quantity: currentQty + 1 });
                        if (r?.result === 'success') {
                            ff.updateSingleProductsPrice(item, item.getAttribute('prod-price'));
                        }
                        ff.resetShippingState();
                        await sf.refreshAndRender();
                        return;
                    }

                    if (e.target.closest('.quantidadeProdutos__btns__sub')) {
                        e.preventDefault();
                        if (currentQty <= 1) {
                            await ApiWS.Calls.cartItemRemove({ itemId, groupId });
                            window.location.reload();
                        } else {
                            if (qtyInput) qtyInput.value = currentQty - 1;
                            await ApiWS.Calls.cartItemUpdate({ itemId, quantity: currentQty - 1 });
                            ff.resetShippingState();
                            await sf.refreshAndRender();
                        }
                        return;
                    }

                    if (e.target.closest('.iconLixeira')) {
                        e.preventDefault();
                        await ApiWS.Calls.cartItemRemove({ itemId, groupId });
                        window.location.reload();
                    }
                });

                container.addEventListener('change', async function (e) {
                    if (!e.target.matches('.quantidadeProdutos__btns__qnt')) return;
                    const item = e.target.closest('.itemCar[itemId]');
                    if (!item || item.getAttribute('storeGift') === 'true') return;
                    const itemId = item.getAttribute('itemId');
                    const newQty = Math.max(1, Math.min(999, Number(e.target.value.replace(/\D/g, '') || 1)));
                    e.target.value = newQty;
                    await ApiWS.Calls.cartItemUpdate({ itemId, quantity: newQty });
                    ff.updateSingleProductsPrice(item, item.getAttribute('prod-price'));
                    ff.resetShippingState();
                    await sf.refreshAndRender();
                });
            }
        },

        async get() {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const shareCartParam = urlParams.get('share_cart');
                if (shareCartParam) {
                    const obfKey = 'kwkbhbvdsojiqwdojr3279tu3qpjawjnvsdjndwopjqwdoh2h9109ejnefj';
                    const sharedToken = shareCartParam.startsWith(obfKey) && shareCartParam.endsWith(obfKey)
                        ? shareCartParam.slice(obfKey.length, -obfKey.length)
                        : shareCartParam;
                    if (sharedToken) {
                        try {
                            const result = await ApiWS.Calls._post('/cart/start-shared', ApiWS.Affiliate.apply({
                                store_id: Number(ApiWS.LV),
                                shared_token: sharedToken,
                            }));
                            if (result?.result === 'success' && result?.record?.cart_token) {
                                localStorage['orderIdKeepTC_B'] = result.record.cart_token;
                            }
                        } catch (e) {
                            console.error('[checkout-cart2] cartStartShared:', e);
                        }
                        window.location.replace('/carrinho');
                        return true;
                    }
                }

                const body = document.querySelector('body');
                if (body) body.style.overflow = 'hidden';
                wsMain.tools.showLoading();

                console.log('%c ws-checkout-cart2 v1.0', 'background: green; color: #FFF');

                wsMain.modules['checkout-cart2'].factoryFunctions.createButtonMsg();
                setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 500);

                const data = await ApiWS.Calls.cartView();

                if (!data?.products) {
                    wsMain.tools.hideLoading();
                    if (body) body.style.overflow = '';
                    return false;
                }

                window.cartJson = data;
                ApiWS.Analytics?.viewCart(data);
                await wsMain.modules['checkout-cart2'].create(data);
                return true;
            } catch (error) {
                console.error('[checkout-cart2] get:', error);
                return false;
            }
        },

        async create(data) {
            try {
                if (!data || !Object.keys(data).length) return false;

                const ff = wsMain.modules['checkout-cart2'].factoryFunctions;
                const sf = wsMain.modules['checkout-cart2'].subFunctions;

                const proxy = new Proxy({ total: 0, qntyToRemove: 0 }, {
                    set(t, k, v) {
                        if (v === t[k]) return false;
                        t[k] = v;
                        if (k === 'total') {
                            ff.updateFinishButton(false);
                            sf.changeResumeTotalProductsLabel(v);
                        }
                        return true;
                    }
                });

                ff.createProds(data.products, proxy);
                ff.renderFreteGratisAlert(Number(data.total || 0), data.shipping);

                const itemsContainer = document.querySelector('#ws-carrinhoNovo .checkout-content .itensCarrinho');
                sf.bindCartEvents(itemsContainer);

                document.querySelector('#ws-carrinhoNovo .optionButtonLimpar')
                    ?.addEventListener('click', () => ff.openCleanCartConfirm(), { once: true });

                document.querySelector('#ws-carrinhoNovo .optionButtonContinuaCompra')
                    ?.addEventListener('click', () => { window.location.href = '/'; });

                ff.createMessageToUser();
                ff.createSharePopup(data?.tc || '');

                // Cupom — botão OK e Enter
                const cupomBtnOk = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom .buttonInserirCupom');
                const cupomInputEl = document.querySelector('#ws-carrinhoNovo #cupomParaEnviar');
                if (cupomBtnOk && !cupomBtnOk.dataset.cart2CupomBound) {
                    cupomBtnOk.dataset.cart2CupomBound = '1';
                    cupomBtnOk.addEventListener('click', () => ff.applyCoupon(cupomInputEl?.value || ''));
                }
                if (cupomInputEl && !cupomInputEl.dataset.cart2CupomBound) {
                    cupomInputEl.dataset.cart2CupomBound = '1';
                    cupomInputEl.addEventListener('keypress', e => {
                        if (e.key === 'Enter') ff.applyCoupon(cupomInputEl.value);
                    });
                }

                // Cupom — botão "Remover cupom"
                const cupomLabelEl = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom > label');
                if (cupomLabelEl && !cupomLabelEl.dataset.cart2RemoveBound) {
                    cupomLabelEl.dataset.cart2RemoveBound = '1';
                    cupomLabelEl.addEventListener('click', async () => {
                        if (!cupomLabelEl.dataset.cart2RemoveCoupon) return;
                        try {
                            const result = await ApiWS.Calls.cartCouponRemove();
                            if (result?.result === 'success') {
                                cupomLabelEl.setAttribute('for', 'inserirCupom');
                                cupomLabelEl.innerHTML = 'Inserir cupom';
                                delete cupomLabelEl.dataset.cart2RemoveCoupon;
                                const cupomDiscount = document.querySelector('#ws-carrinhoNovo .resumo .validCupomDiscount');
                                if (cupomDiscount) cupomDiscount.style.display = 'none';
                                await sf.refreshAndRender();
                            }
                        } catch (e) {
                            console.error('[checkout-cart2] cartCouponRemove:', e);
                        }
                    });
                }

                // CEP input — mask, Enter, button click
                const cepInput = document.querySelector('#ws-carrinhoNovo .frete .cepInput__infos input[cart-checkout-input="cep"]');
                const cepBtn = document.querySelector('#ws-carrinhoNovo .frete .cepInput__infos [loaders-type="btn"][btn-type="cep"]');

                if (cepInput && !cepInput.dataset.cart2CepBound) {
                    cepInput.dataset.cart2CepBound = '1';

                    cepInput.addEventListener('input', e => {
                        let v = e.target.value.replace(/\D/g, '');
                        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5, 8);
                        e.target.value = v;
                    });

                    cepInput.addEventListener('keypress', e => {
                        if (e.key === 'Enter') sf.calcularFrete(cepInput.value);
                    });
                }

                if (cepBtn && !cepBtn.dataset.cart2CepBound) {
                    cepBtn.dataset.cart2CepBound = '1';
                    cepBtn.addEventListener('click', () => sf.calcularFrete(cepInput?.value || ''));
                }

                // Pre-fill CEP from localStorage
                const savedCep = localStorage.getItem('CEP_CART_KEEP');
                if (savedCep && cepInput && !cepInput.value) {
                    const masked = savedCep.length === 8 ? savedCep.slice(0, 5) + '-' + savedCep.slice(5) : savedCep;
                    cepInput.value = masked;
                }

                // Frete já escolhido numa visita anterior — o /cart/view traz
                // shipping.selected + shipping.zip_code. Dispara o cálculo
                // automaticamente pra popular a lista de métodos e re-selecionar
                // o escolhido (createFreightLabel marca o record com selected:true
                // e chama selectShipping nele). Mesmo resultado de o cliente
                // abrir a página e clicar em "Calcular". Só uma vez por
                // carregamento — não repete a cada re-render (cupom, qtd, etc.).
                if (!sf._autoCalcFreteDone && data.shipping?.selected) {
                    sf._autoCalcFreteDone = true;
                    const autoZip = String(data.shipping.zip_code || savedCep || cepInput?.value || '').replace(/\D/g, '');
                    if (autoZip.length === 8) {
                        if (cepInput && !cepInput.value) cepInput.value = autoZip.slice(0, 5) + '-' + autoZip.slice(5);
                        sf.calcularFrete(autoZip);
                    }
                }

                // Multi CD: alterar o carrinho apaga a alocação por CD e o frete
                // escolhido (ApiWS.Calls.cartItem* deixa o aviso, que sobrevive
                // ao reload de quando um item é removido) — recalcula sozinho.
                if (ApiWS.MultiCd.consumeRecalcFlag()) {
                    sf._autoCalcFreteDone = true;
                    sf.recalcFreteMultiCd();
                }

                // Botão "Finalizar compra" — fecha pedido via /cart/close e redireciona ao checkout
                document.querySelectorAll('#ws-carrinhoNovo .buttonFinalizar:not(.ws-checkout-init-btn-finish)').forEach(btn => {
                    if (btn.dataset.cart2FinishBound) return;
                    btn.dataset.cart2FinishBound = '1';
                    btn.addEventListener('click', async () => {
                        if (btn.classList.contains('finishNotReady')) return;
                        // Multi CD: item sem estoque em nenhum CD ou pacote sem forma
                        // de envio não deixam avançar.
                        const multiCdBlock = sf._multiCd ? ApiWS.MultiCd.blockReason(sf._multiCd.parsed) : '';
                        if (multiCdBlock) {
                            ff.showFreteError(multiCdBlock);
                            wsMain.showAlert(multiCdBlock, 'Atenção');
                            return;
                        }

                        ff.updateFinishButton(false);
                        try {
                            // Calcular/selecionar frete não é mais obrigatório pra sair do
                            // /carrinho — tenha ou não frete a calcular, quem não escolheu
                            // aqui segue pro checkout e resolve lá (mesma etapa "Formas de
                            // envio" da wsapi3-checkout-payment-page, que já lida com isso).
                            // shippingOnCheckout:true sempre, igual o carrinho lateral já
                            // faz (ver wsapi3-cart-sidebar.js/wsapi3-cart-drawer-rules.js) —
                            // sem ele o /cart/close exigiria uma seleção de frete já feita.
                            const result = await ApiWS.Calls.cartClose({ shippingOnCheckout: true });
                            if (result?.result === 'success' && result?.record) {
                                const { cart_token, checkout_token, order_number } = result.record;
                                const params = new URLSearchParams({ ct: cart_token, ct2: checkout_token, order_number });
                                window.location.href = `/checkout?${params.toString()}`;
                            } else {
                                ff.updateFinishButton(true);
                                wsMain.showAlert(result?.message || 'Não foi possível finalizar o pedido.', 'Atenção');
                                // Estoque/alocação por CD mudou ou falta frete de algum pacote.
                                if (ApiWS.MultiCd.needsRecalc(result)) sf.recalcFreteMultiCd(result.message);
                            }
                        } catch (e) {
                            console.error('[checkout-cart2] cartClose:', e);
                            ff.updateFinishButton(true);
                            wsMain.showAlert('Erro ao finalizar o pedido. Tente novamente.', 'Atenção');
                        }
                    });
                });

                ff.createResumeInfos(data);

                if (!data.sendable) {
                    document.querySelector('#ws-carrinhoNovo .resumoItem.taxaEntrega')?.style.setProperty('display', 'none');
                    document.querySelector('#ws-carrinhoNovo #frete-section')?.style.setProperty('display', 'none');
                    document.querySelector('#ws-carrinhoNovo')?.classList.add('noShipping');
                }

                if (!data.accept_coupon) {
                    const cupomEl = document.querySelector('#ws-carrinhoNovo .resumo .inserirCupom');
                    if (cupomEl) {
                        cupomEl.classList.remove('resume-bottom-border');
                        cupomEl.style.display = 'none';
                        const prev = cupomEl.previousElementSibling;
                        if (prev) prev.classList.add('resume-bottom-border');
                    }
                }

                wsMain.modules['checkout-cart2'].finishLoader();
                return true;
            } catch (error) {
                console.error('[checkout-cart2] create:', error);
                return false;
            }
        },

        observer(resumeContainer, data) {
            if (window.innerWidth > 800) return;
            const floatResume = document.querySelector('.float-resume');
            const resume = document.querySelector('#ws-carrinhoNovo .resumo');
            if (!floatResume || !resume) return;

            floatResume.setAttribute('float-resume', 'active');
            wsMain.modules['checkout-cart2'].factoryFunctions.createMobileResumeInfos();

            if (floatResume.dataset.cart2ObserverActive) return;
            floatResume.dataset.cart2ObserverActive = '1';

            window.addEventListener('scroll', () => {
                const rect = resume.getBoundingClientRect();
                floatResume.setAttribute('float-resume', (rect.top + 70) > window.innerHeight ? 'active' : 'off');
            });
        },

        finishLoader() {
            setTimeout(() => {
                const body = document.querySelector('body');
                const footer = document.querySelector('footer');
                const content = document.querySelector('#ws-carrinhoNovo .checkout-content');
                wsMain.tools.hideLoading();
                if (body) body.style.overflow = 'initial';
                if (footer) footer.classList.remove('startingCart');
                if (content) content.classList.remove('startingCart');
            }, 1500);
        }
    });
})();

/* ===========================================
   MODULE: GIFT SLIDER
   Portado para ws-checkout-cart2 — NÃO editar no default module ws-checkout-cart
   =========================================== */

var WS_GIFT_SLIDER_DEBUG = false;

function wsGiftLog() {
    if (!WS_GIFT_SLIDER_DEBUG) return;
    try { console.log.apply(console, arguments); } catch (_) { }
}

setTimeout(function () {
    wsMain.createModule({
        name: "gift-slider",
        function: "get",
        subFunctions: {
            createAncors() {
                const pageWidth = window.innerWidth;
                const wsGiftsAnchor = document.querySelector('[data-ws-ancor="gifts"]');
                const hasWsAnchor = !!wsGiftsAnchor;

                wsGiftLog("[gift-slider] createAncors() | anchor [data-ws-ancor='gifts'] existe:", hasWsAnchor);

                if (hasWsAnchor) {
                    try { wsMain.modules["gift-slider"].destroyCreatedAnchors(); } catch (_) { }
                    const targetType = pageWidth < 1000 ? "checkoutMobile" : "checkout";
                    wsGiftsAnchor.setAttribute("cart-gift-slider", targetType);
                    wsGiftsAnchor.setAttribute("data-gift-slider-created", "0");
                    wsGiftsAnchor.dataset.wsGiftsMounted = "1";
                    wsGiftLog("[gift-slider] createAncors() | âncora custom configurada como:", targetType);
                    return;
                }

                // Não escopar mais em "header .header-top" — o wsapi3-cart-drawer-rules
                // move o .cart-holder pra ser filho direto do <body> (precisava sair de
                // dentro do header pro z-index competir certo com o #overlay), então
                // esse seletor teria parado de encontrar o drawer.
                let topo = document.querySelector(".cart-holder");
                const cartDrawerAncor = pageWidth < 1000 ? "cartDrawerMobile" : "cartDrawer";

                if (topo) {
                    const alreadyGlobal = document.querySelector(`[cart-gift-slider="${cartDrawerAncor}"]`);
                    if (!alreadyGlobal) {
                        // .cart-items-holder não é mais filho direto de .cart-holder
                        // (agora fica dentro de .cd-scroll-area) — insertBefore exige
                        // que o nó de referência seja filho direto de quem chama o
                        // método, senão lança DOMException e cai no catch silenciosamente.
                        // Insere relativo ao PARENT real do items-holder, não a "topo".
                        const itemsHolder = topo.querySelector(".cart-items-holder");
                        if (itemsHolder && itemsHolder.parentNode) {
                            const cartDrawerElm = wsMain.tools.createElm({
                                type: "div",
                                attrs: { "cart-gift-slider": cartDrawerAncor, "data-gift-slider-created": "1" },
                            });
                            itemsHolder.parentNode.insertBefore(cartDrawerElm, itemsHolder);
                        }
                    }
                }
            },

            treatMoney(value) {
                try {
                    const n = Number(value);
                    if (!isFinite(n)) return "R$ 0,00";
                    if (wsMain?.data?.treatPrice) return wsMain.data.treatPrice(n);
                } catch (_) { }
                try {
                    return (Number(value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
                } catch (_) { }
                return "R$ 0,00";
            },

            getCartJson() {
                wsGiftLog("[gift-slider] getCartJson() | tentando obter cartJson...");
                try {
                    if (window.cartJson && typeof window.cartJson === "object") {
                        wsGiftLog("[gift-slider] getCartJson() | encontrado em window.cartJson");
                        return window.cartJson;
                    }
                } catch (e) {
                    wsGiftLog("[gift-slider] getCartJson() | window.cartJson erro:", e);
                }
                wsGiftLog("[gift-slider] getCartJson() | NÃO encontrado (null)");
                return null;
            },

            getCartSignature(cart) {
                try {
                    if (!cart || typeof cart !== "object") return "";
                    const sig = `${cart.version || ""}|${cart.lastUpdate || ""}|${cart.total || ""}|${cart.subtotal || ""}|${Array.isArray(cart.gifts) ? cart.gifts.length : 0}|${Array.isArray(cart.products) ? cart.products.length : 0}`;
                    wsGiftLog("[gift-slider] getCartSignature() | signature:", sig);
                    return sig;
                } catch (e) { return ""; }
            },

            createGiftCard(gift, cartSubtotal, isChosen, chosenItemId) {
                try {
                    if (!gift || !gift.gift_product) return null;
                    const gp = gift.gift_product;
                    const applicable = !!gift.applicable;
                    const img = gp.photo
                        ? `<img src="${gp.photo}" alt="${(gp.name || "").replace(/"/g, "&quot;")}">`
                        : `<img src="/lojas/img/sem-foto.jpg" alt="Produto sem foto" width="600" height="600" loading="lazy">`;

                    let statusHtml = "";
                    if (isChosen) {
                        statusHtml = `<span class="gift__status gift__status--chosen">Escolhido</span>`;
                    } else if (applicable) {
                        statusHtml = `<span class="gift__status gift__status--ok">Dispon&iacute;vel</span>`;
                    } else {
                        const missing = Number(gift.min_value_applied || 0) - Number(cartSubtotal || 0);
                        statusHtml = `<span class="gift__status gift__status--wait">Ainda n&atilde;o liberado</span>${missing > 0 ? `<span class="gift__missing">Faltam ${this.treatMoney(missing)}</span>` : ""}`;
                    }

                    let actionHtml = "";
                    if (!isChosen && applicable) {
                        actionHtml = chosenItemId
                            ? `<a class="chosegift_btn" href="javascript:void(func_chose_gift(${gp.id}, ${chosenItemId}))">Quero esse brinde</a>`
                            : `<a class="chosegift_btn" href="javascript:void(func_chose_gift(${gp.id}))">Quero esse brinde</a>`;
                    }

                    return wsMain.tools.createElm({
                        type: "div",
                        attrs: { class: `gift-prod ${applicable ? "is-applicable" : "not-applicable"} ${isChosen ? "is-chosen" : ""}` },
                        innerHTML: `
                            <div class="gift__image-container"><div class="gift__image-link">${img}</div></div>
                            <div class="gift__infos-container">
                                <p class="gift__name">${gp.name || "Brinde"}</p>
                                <div class="gift__meta">${statusHtml}</div>
                                <div class="gift__action">${actionHtml}</div>
                            </div>`,
                    });
                } catch (e) { wsGiftLog("[gift-slider] createGiftCard() | erro:", e); return null; }
            },

            getGiftsSignature(cartOrGifts) {
                try {
                    const isCart = cartOrGifts && typeof cartOrGifts === "object" && Array.isArray(cartOrGifts.gifts);
                    const gifts = isCart ? cartOrGifts.gifts : cartOrGifts;
                    if (!Array.isArray(gifts) || gifts.length === 0) return "nogifts";

                    const cartSkus = isCart && Array.isArray(cartOrGifts.products)
                        ? cartOrGifts.products.map(p => p?.sku ? String(p.sku).trim() : "").filter(Boolean)
                        : [];

                    const parts = gifts.map(g => {
                        const gp = g?.gift_product || {};
                        const giftSku = gp?.sku ? String(gp.sku).trim() : "";
                        const chosen = giftSku && cartSkus.length ? (cartSkus.includes(giftSku) ? "1" : "0") : "0";
                        return `${g?.id ?? ""}:${chosen}:${g?.applicable ? "1" : "0"}:${Number(g?.min_value_applied || 0)}:${gp?.id ?? gp?.sku ?? ""}:${(gp?.name || "").trim()}:${gp?.photo || ""}`;
                    });
                    parts.sort();
                    const sig = parts.join("|");
                    wsGiftLog("[gift-slider] getGiftsSignature() | sig:", sig);
                    return sig;
                } catch (e) { return ""; }
            },
        },

        async get() {
            try {
                wsGiftLog("[gift-slider] get() | iniciado");
                wsMain.modules["gift-slider"].subFunctions.createAncors();
                wsHideGiftsAnchor();
                wsMain.modules["gift-slider"].updateFromCartJson(false);
                return wsMain.modules["gift-slider"].watching();
            } catch (error) { wsGiftLog("[gift-slider] get() | error:", error); return false; }
        },

        async watching(lastSignature = "", cycle = 0) {
            try {
                const check = async () => {
                    cycle++;
                    const cart = wsMain.modules["gift-slider"].subFunctions.getCartJson();

                    if (!cart) {
                        wsGiftLog("[gift-slider] watching() | cartJson ainda não disponível, tentando novamente...");
                        wsMain.modules["gift-slider"].watching(lastSignature, cycle);
                        return;
                    }

                    const signature = wsMain.modules["gift-slider"].subFunctions.getCartSignature(cart);
                    const giftsSig = wsMain.modules["gift-slider"].subFunctions.getGiftsSignature(cart);
                    const hasRenderedBlock = !!document.querySelector('[cart-gift-slider][data-ws-gifts-sig]');
                    const versionNow = cart?.version || "";
                    const lastVersion = wsMain.modules["gift-slider"]._lastVersion || "";

                    wsGiftLog("[gift-slider] watching() | cycle:", cycle, "| sig:", signature, "| giftsSig:", giftsSig, "| version:", versionNow);

                    if (versionNow && versionNow !== lastVersion) {
                        wsMain.modules["gift-slider"]._lastVersion = versionNow;
                        wsMain.modules["gift-slider"].destroyCreatedAnchors();
                        wsMain.modules["gift-slider"].subFunctions.createAncors();

                        const hasRenderedAfter = !!document.querySelector('[cart-gift-slider][data-ws-gifts-sig]');
                        if (!hasRenderedAfter) {
                            wsMain.modules["gift-slider"].updateFromCartJson(false);
                        } else {
                            const any = document.querySelector('[cart-gift-slider][data-ws-gifts-sig]');
                            const renderedSig = any?.getAttribute("data-ws-gifts-sig") || "";
                            if (renderedSig !== giftsSig) wsMain.modules["gift-slider"].updateFromCartJson(false);
                        }
                        wsMain.modules["gift-slider"].watching(signature, cycle);
                        return;
                    }

                    if (hasRenderedBlock) {
                        const any = document.querySelector('[cart-gift-slider][data-ws-gifts-sig]');
                        const renderedSig = any?.getAttribute("data-ws-gifts-sig") || "";
                        if (renderedSig && renderedSig === giftsSig) {
                            wsMain.modules["gift-slider"].watching(signature, cycle);
                            return;
                        }
                    }

                    if (signature && signature !== lastSignature) {
                        wsMain.modules["gift-slider"].updateFromCartJson(true);
                        wsMain.modules["gift-slider"].watching(signature, cycle);
                        return;
                    }

                    wsMain.modules["gift-slider"].watching(lastSignature, cycle);
                };
                setTimeout(check, 1000);
                return true;
            } catch (error) { wsGiftLog("[gift-slider] watching() | error:", error); return false; }
        },

        _lastVersion: "",

        updateFromCartJson(update) {
            try {
                const cart = wsMain.modules["gift-slider"].subFunctions.getCartJson();
                const gifts = cart?.gifts;

                wsGiftLog("[gift-slider] updateFromCartJson() | cart:", !!cart, "| gifts:", Array.isArray(gifts) ? gifts.length : "n/a");

                if (!Array.isArray(gifts) || gifts.length === 0) {
                    wsMain.modules["gift-slider"].clear(update);
                    wsHideGiftsAnchor();
                    return false;
                }

                const newSig = wsMain.modules["gift-slider"].subFunctions.getGiftsSignature(cart);
                const allAncors = document.querySelectorAll("[cart-gift-slider]");
                let changed = false;
                allAncors.forEach(ancor => {
                    const oldSig = ancor.getAttribute("data-ws-gifts-sig") || "";
                    if (!oldSig || oldSig !== newSig) changed = true;
                });

                if (!changed) { wsShowGiftsAnchor(); return true; }

                wsMain.modules["gift-slider"].create(gifts, cart, update);
                return true;
            } catch (error) { wsGiftLog("[gift-slider] updateFromCartJson() | error:", error); return false; }
        },

        async create(giftsArr, cartJson, update) {
            try {
                if (!Array.isArray(giftsArr) || giftsArr.length === 0) return;
                const pageWidth = window.innerWidth;
                const giftsCount = giftsArr.length;

                const sliderOptionsObj = {
                    checkout() {
                        const perView = giftsCount <= 2 ? 2 : 2.5;
                        return `slides.perView:${perView};slides.spacing:20;dots:false;loop:false;dotsType:group;`;
                    },
                    cartDrawer() {
                        const perView = giftsCount <= 1 ? 1 : 1.2;
                        return `slides.perView:${perView};slides.spacing:16;dots:false;dotsType:group;loop:false;`;
                    },
                    checkoutMobile() { return `slides.perView:1.5;slides.spacing:12;dots:false;arrows:false;loop:false;dotsType:group;`; },
                    cartDrawerMobile() { return `slides.perView:1.5;slides.spacing:12;dots:false;arrows:false;loop:false;dotsType:group;`; },
                };

                const cartDrawerAncor = pageWidth < 800 ? "cartDrawerMobile" : "cartDrawer";
                const allAncors = update
                    ? document.querySelectorAll(`[cart-gift-slider="${cartDrawerAncor}"],[cart-gift-slider="checkout"],[cart-gift-slider="checkoutMobile"]`)
                    : document.querySelectorAll("[cart-gift-slider]");

                wsGiftLog("[gift-slider] create() | anchors:", allAncors?.length, "| update:", !!update);

                const cartSubtotal = Number(cartJson?.subtotal || 0);
                const newSig = wsMain.modules["gift-slider"].subFunctions.getGiftsSignature(cartJson || { gifts: giftsArr, products: [] });

                const cartSkus = Array.isArray(cartJson?.products)
                    ? cartJson.products.map(p => p?.sku ? String(p.sku).trim() : "").filter(Boolean)
                    : [];
                const giftSkus = giftsArr.map(g => g?.gift_product?.sku ? String(g.gift_product.sku).trim() : "").filter(Boolean);

                const chosenCartProduct = Array.isArray(cartJson?.products)
                    ? cartJson.products.find(p => { const s = p?.sku ? String(p.sku).trim() : ""; return s && giftSkus.includes(s); })
                    : null;
                const chosenItemId = chosenCartProduct?.itemId || null;

                const isGiftChosenBySku = gift => {
                    const sku = gift?.gift_product?.sku ? String(gift.gift_product.sku).trim() : "";
                    return sku && cartSkus.length ? cartSkus.includes(sku) : false;
                };

                const giftsSorted = giftsArr
                    .map((g, i) => ({ g, i, chosen: isGiftChosenBySku(g) }))
                    .sort((a, b) => a.chosen === b.chosen ? a.i - b.i : a.chosen ? -1 : 1)
                    .map(x => x.g);

                allAncors.forEach((ancor, idx) => {
                    if (!ancor) return;
                    const ancorAttrValue = ancor.getAttribute("cart-gift-slider");
                    const dataWsjsSlide = sliderOptionsObj[ancorAttrValue]?.();
                    if (!dataWsjsSlide) return;

                    const oldSig = ancor.getAttribute("data-ws-gifts-sig") || "";
                    if (oldSig && oldSig === newSig) { wsShowGiftsAnchor(); return; }

                    ancor.setAttribute("data-ws-gifts-sig", newSig);
                    ancor.setAttribute("data-wsjs-slide", dataWsjsSlide);
                    ancor.innerHTML = "";

                    ancor.append(wsMain.tools.createElm({ type: "div", attrs: { class: "container" } }));
                    const ancorContainer = ancor.querySelector(".container");
                    ancorContainer.append(
                        wsMain.tools.createElm({ type: "div", attrs: { class: "gift__title" }, innerHTML: `<h2>Brindes</h2>` }),
                        wsMain.tools.createElm({ type: "div", attrs: { class: "gift__sliderProds" } })
                    );

                    const containerToGifts = ancor.querySelector(".gift__sliderProds");
                    containerToGifts.style.opacity = 0;

                    giftsSorted.forEach(gift => {
                        const giftElm = wsMain.modules["gift-slider"].subFunctions.createGiftCard(gift, cartSubtotal, isGiftChosenBySku(gift), chosenItemId);
                        if (giftElm) containerToGifts.append(giftElm);
                    });

                    // A âncora [data-ws-ancor="gifts"] começa com style="display:none"
                    // no HTML estático — precisa ficar visível ANTES do createSlide(),
                    // senão o KeenSlider mede a largura do container com display:none
                    // (0px) e só recalcula certo depois de um resize real da janela
                    // (era exatamente o sintoma "só corrige se redimensionar").
                    wsShowGiftsAnchor();

                    // No drawer os brindes ficam em lista (um abaixo do outro),
                    // não em slider — só o "checkout"/"checkoutMobile" (página
                    // completa do carrinho) ainda usa o keen-slider.
                    const isDrawerAncor = ancorAttrValue === "cartDrawer" || ancorAttrValue === "cartDrawerMobile";
                    if (!isDrawerAncor) {
                        const sliderOptions = wsMain.tools.getWsData(ancor, "slide");
                        const [sliderVrf, slider] = wsMain.tools.createSlide(containerToGifts, sliderOptions);
                        if (sliderVrf) slider.update();
                    }

                    containerToGifts.style.opacity = 1;
                });

                return true;
            } catch (error) { wsGiftLog("[gift-slider] create() | error:", error); return false; }
        },

        destroyCreatedAnchors() {
            try {
                document.querySelectorAll('[data-gift-slider-created="1"]').forEach(el => { try { el.remove(); } catch (_) { } });
                return true;
            } catch (error) { return false; }
        },

        async clear(update) {
            try {
                const cartDrawerAncor = window.innerWidth < 800 ? "cartDrawerMobile" : "cartDrawer";
                const allAncors = update
                    ? document.querySelectorAll(`[cart-gift-slider="${cartDrawerAncor}"]`)
                    : document.querySelectorAll("[cart-gift-slider]");
                allAncors.forEach(ancor => { if (ancor) ancor.innerHTML = ""; });
                return true;
            } catch (error) { return false; }
        },
    });

    wsMain.modules["gift-slider"].get();
}, 3000);

function wsGetGiftsAnchor() { return document.querySelector('[data-ws-ancor="gifts"]'); }

function wsShowGiftsAnchor() { const a = wsGetGiftsAnchor(); if (a) a.style.display = ""; }

function wsHideGiftsAnchor() { const a = wsGetGiftsAnchor(); if (a) a.style.display = "none"; }

async function func_chose_gift(productId, removeItemId) {
    wsMain.tools.showLoading();
    try {
        if (removeItemId) {
            await ApiWS.Calls.cartItemRemove({ itemId: removeItemId });
        }
        await ApiWS.Calls.cartAddItem({ productId: productId, quantity: 1, isGift: true });
        const fresh = await ApiWS.Calls.cartView();
        if (fresh?.products !== undefined) {
            window.cartJson = fresh;
            await wsMain.modules['checkout-cart2'].create(fresh);
        }
    } catch (e) {
        console.error('[gift-slider] func_chose_gift error:', e);
    } finally {
        wsMain.tools.hideLoading();
    }
}
